module.exports = __webpack_public_path__ + "img/booth-piano.0f837a20.jpg";